import React, { Component } from "react";


const labelStyle = {
    width: '140px',
    textAlign: 'right',
    marginRight: '5px'
};

const divInputStyle = {
    width: '500px'
};


export class CompanyList extends Component {
    static displayName = CompanyList.name;

    constructor(props) {
        super(props);
        this.state = { LicensePlate: '', LicensePlateState: '', Items: [] };
        this.setLicensePlateState = this.setLicensePlateState.bind(this);
        this.submitForm = this.submitForm.bind(this);
    }

    // as an example of one way to set state
    setLicensePlateState(value) {
        this.setState({
            //LicensePlate: this.state.LicensePlate,
            LicensePlateState: value
        });
    }




    submitForm() {
        fetch("/pp/configService.asmx/getCompanies", {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then(r => r.json())
        //.then(r => { console.log(r) });
        .then(r => {
                this.setState({
                    Items: r.d
                });
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                this.setState({
                    isLoaded: true,
                    error
                });
            }
        );
        var i = 0;
    }

    // this has to be static to be used to write sub-content
    static renderList(items) {
        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Company</th>
                        <th>ID</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map(item =>
                        <tr key={item.CompanyID}>
                            <td>{item.CompanyName}</td>
                            <td>{item.CompanyID}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }




    render() {
        let contents = CompanyList.renderList(this.state.Items);

        return (
            <div>
                <h1>Company list</h1>
                <br />
                <button className="btn btn-primary" onClick={this.submitForm}>Submit</button>
                <br />
                <br />
                {contents}
            </div>
        );
    }
}
